export default __webpack_public_path__ + "static/media/4.b4fd9810.png";